enum AccountSearchType {
    AccountName = "ACCOUNT_NAME",
    AccountIdentifier = "ACCOUNT_IDENTTIFIER",
    CustomerName = "CUSTOMER_NAME",
}
export default AccountSearchType